import { useRef, useEffect, useCallback, useState } from "react";
import { createHeader, createRemisionRow } from "@utils/utils";
import RemisionesUI from "./RemisionesUI";
import { remisionService } from "@services/RemisionService";
import { ITableRow, IDataPage, RemisionState } from "../../../types/global";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
import { authService } from "@services/authService";
const Remisiones = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<ITableRow[]>([]);
  const [remisiones, setRemisiones] = useState<IDataPage>({});
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [search, setSearch] = useState("");
  const [stateFilter, setStateFilter] = useState<RemisionState | undefined>(undefined);
  const isAdmin = authService.isAdmin();
  const debouncedSearch = useRef(debounce(value => setSearch(value), 800)).current;
  const rowsPerPage = 6;
  const handleStatusFilter = (option: string) => {
    setStateFilter(option ? (option as RemisionState) : undefined);
  };
  const getAllRemisiones = useCallback(async (skipPage = 0, localSearch = "", localStateFilter: RemisionState | undefined = stateFilter) => {
    try {
      setIsLoading(true);
      const res = await remisionService.getAll(rowsPerPage, skipPage * rowsPerPage, localSearch, localStateFilter);
      const localPages = Math.ceil(res.data.totalCount / rowsPerPage);
      if (localPages < currentPage) {
        setCurrentPage(1);
        return;
      }
      setPages(localPages);
      setRemisiones(prev => ({
        ...prev,
        [skipPage + 1]: {
          search: localSearch,
          stateFilter: localStateFilter,
          items: [...res.data.items.map(remision => createRemisionRow(remision.id, remision.name, remision.clientName, remision.creationTime, remision.limitDate, remision.total, remision.state, remision.receiptType))]
        }
      }));
    } catch {
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  }, [stateFilter, currentPage]);
  useEffect(() => {
    setCurrentPage(1);
  }, [search]);
  useEffect(() => {
    setRows([]);
    const data = remisiones[currentPage];
    if (data && data.search === search && data.stateFilter === stateFilter) {
      setRows(data.items);
    } else {
      getAllRemisiones(currentPage - 1, search, stateFilter);
    }
  }, [remisiones, getAllRemisiones, currentPage, search, stateFilter]);
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  const headers = [createHeader("Nombre", "name"), createHeader("Cliente", "clientName"), createHeader("Fecha de creación", "creationTime"), createHeader("Fecha límite", "limitDate"), createHeader("Total", "balance"), createHeader("Estado", "status"), createHeader("Acciones", "actions")];
  return <RemisionesUI isLoading={isLoading} showError={showError} closeError={() => setShowError(false)} errorMessage="Hubo problemas para consultar" headers={headers} rows={rows} onClick={() => navigate("/remisiones/crear")} pages={pages} currentPage={currentPage} onChangePage={setCurrentPage} onSearch={(value: string) => debouncedSearch(value)} onSearchClick={() => getAllRemisiones(currentPage - 1, search)} isAdmin={isAdmin} handleStatusFilter={handleStatusFilter} />;
};
export default Remisiones;